/**
 * SkeletonShimmer — glassmorphic loading placeholders.
 * Use in place of content while data loads.
 */
export function SkeletonLine({ className = "", width = "100%" }) {
  return (
    <div
      className={`animate-pulse rounded-lg bg-white/5 ${className}`}
      style={{ width, height: "1em" }}
    >
      <div className="h-full w-full rounded-lg bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />
    </div>
  );
}

export function SkeletonCard({ className = "" }) {
  return (
    <div
      className={`rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-8 space-y-4 ${className}`}
    >
      <SkeletonLine width="40%" className="h-4" />
      <SkeletonLine width="80%" className="h-3" />
      <SkeletonLine width="60%" className="h-3" />
      <div className="pt-2">
        <SkeletonLine width="30%" className="h-8 rounded-full" />
      </div>
    </div>
  );
}

export function SkeletonHero() {
  return (
    <div className="space-y-6 max-w-3xl">
      <SkeletonLine width="120px" className="h-6 rounded-full" />
      <SkeletonLine width="90%" className="h-12" />
      <SkeletonLine width="70%" className="h-12" />
      <SkeletonLine width="60%" className="h-5" />
      <div className="flex gap-4 pt-4">
        <SkeletonLine width="160px" className="h-12 rounded-full" />
        <SkeletonLine width="160px" className="h-12 rounded-full" />
      </div>
    </div>
  );
}
